// PageMeta — per-route title / meta / OG overrides on top of the
// defaults set in public/index.html. Only the fields passed get
// overridden; everything else falls back to index.html.
//
// SPAs can't prerender, so these only populate after JS runs — meaning
// Googlebot sees them (it executes JS), but non-JS AI crawlers (most)
// still see the generic index.html. For AI crawlers we rely on
// /sitemap.xml, /llms.txt, /api/events.jsonld. For Google we add these
// runtime overrides so each route has a unique searchable title.

import { Helmet } from 'react-helmet-async';

const BASE = 'https://www.orangelabel.io';
const DEFAULT_IMAGE = `${BASE}/logos/orangelabel.png`;
const DEFAULT_DESCRIPTION = 'A global directory of Bitcoin-accepting businesses, meetup groups, and Bitcoin Walks.';

const PageMeta = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '',
  image = DEFAULT_IMAGE,
  type = 'website',
  jsonLd,
}) => {
  const fullTitle = title ? `${title} · OrangeLabel.io` : 'OrangeLabel.io — Global directory of Bitcoin-accepting businesses & meetups';
  const url = `${BASE}${path || ''}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default PageMeta;
